<template>
  <div class="mb-4">
    <!-- Begin Recommendation  -->
    <div v-if="recommendationAvailable" class="d-flex align-items-center float-right">
      <div class="d-flex align-items-center">
        <div class="d-flex align-items-center">
          <label class="switch-label  mt-1 mr-1"
            ><strong>{{ $t("common.recommendations") }}</strong></label
          >
          <b-form-checkbox
            ref="recommendationCheckbox"
            @change="$root.$emit('bv::toggle::collapse', 'add-applied-control-panel')"
            v-model="isChecked"
            name="check-button"
            switch
            class="switch"
          ></b-form-checkbox>
        </div>

        <right-panel class="float-right" id="add-applied-control-panel" width="600px" :icon="'mdi mdi-plus'" @hidden="rightPanelClosed">
          <div class="pl-5 pr-5">
            <h4 class="mt-4">
              {{ $t("risk.applied-control.recommendation") }}
            </h4>

            <empty v-if="!recommendations || recommendations.docs.length == 0" width="100px" />
            <div v-if="recommendations">
              <div>
                <div class="d-flex flex-row " v-if="recommendations && recommendations.docs.length > 0">
                  <div class="mr-3">
                    <button @click="selectAllItems" class="btn btn-sm btn-secondary">
                      <b> {{ selectedItems.length > 0 ? $t("common.deselect-all") : $t("common.select-all-items") }}</b>
                    </button>
                  </div>
                  <div>
                    <button
                      class="btn btn-sm btn-success"
                      variant="success"
                      @click="applyRecommendation(selectedItems)"
                      v-if="isAtLeastOneItemSelected"
                      :disabled="!isAtLeastOneItemSelected"
                    >
                      <i class="mdi mdi-plus text-success" v-b-tooltip.hover :title="$t('common.apply-recommendation')"></i> {{ $t("common.apply-recommendation") }} ({{
                        selectedItems.length
                      }})
                    </button>
                  </div>
                </div>

                <table class="table project-list-table compact">
                  <tbody>
                    <tr class="hider" v-for="item in recommendations.docs" :key="item._id">
                      <td>
                        <div class="text-center">
                          <b-form-checkbox v-model="selectedItems" :value="item" class="custom-checkbox-arimary mb-1 " checked></b-form-checkbox>
                        </div>
                      </td>
                      <td>{{ item.name | translate }}</td>
                      <td>
                        <i
                          class="mdi mdi-plus float-right text-success hand hidden mt-1 mr-2"
                          v-b-tooltip.hover
                          :title="$t('common.apply-recommendation')"
                          @click="applyRecommendation(item)"
                        ></i>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <!-- Begin: Pagination -->

              <div class="row">
                <div class="col">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="recommendationRequest.options.page"
                      :total-rows="recommendations.totalDocs"
                      :per-page="recommendations.limit"
                      limit="10"
                      size="sm"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
              <!-- End: Pagination -->
            </div>

            <!-- Begin: Pagination
      <div v-if="recommendations" class="row">
        <div class="col">
          <ul class="pagination pagination-rounded mb-0">
            <b-pagination
              v-model="recommendationRequest.options.page"
              :total-rows="recommendations.totalDocs"
              :per-page="recommendations.limit"
              limit="10"
              size="sm"
            ></b-pagination>
          </ul>
        </div>
      </div>
      <hr /> -->
          </div>
        </right-panel>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["riskDefinition", "multiSelectEnabled"],
  data() {
    return {
      isChecked: false,
      selectedItems: [],
      recommendationRequest: {
        options: { page: 1, limit: 5 },
        query: {},
      },
    };
  },
  computed: {
    isAtLeastOneItemSelected() {
      return this.selectedItems.length > 0;
    },
    showRecommendations: {
      get() {
        return this.$store.getters["riskAppliedControlRecommendation/showRecommendations"];
      },
      set(value) {
        this.$store.commit("riskAppliedControlRecommendation/showRecommendations", value);
      },
    },
    recommendations() {
      return this.$store.getters["riskAppliedControlRecommendation/recommendations"];
    },
    recommendationAvailable() {
      return this.recommendations?.docs?.length > 0;
    },
  },

  watch: {
    riskDefinition: {
      handler() {
        this.debounceMixin(() => this.fethcRecommendation());
      },
    },

    recommendationRequest: {
      deep: true,
      immediate: true,
      handler() {
        this.fethcRecommendation();
      },
    },
  },
  methods: {
    selectAllItems() {
      if (this.selectedItems.length > 0) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.recommendations?.docs?.slice() || [];
      }
    },
    rightPanelClosed() {
      this.isChecked = false;
      this.selectedItems = [];
    },
    async fethcRecommendation() {
      const isLoading = this.$store.getters["riskAppliedControlRecommendation/isLoading"];
      if (isLoading) {
        return;
      }
      await this.$store.dispatch("riskAppliedControlRecommendation/paginateRecommendation", { pagination: this.recommendationRequest, riskDefinition: this.riskDefinition });
    },

    applyRecommendation(item) {
      if (!Array.isArray(item)) {
        item = [item];
      }
      this.$emit("onApply", item);
      this.selectedItems = [];
      this.$root.$emit("bv::toggle::collapse", "add-applied-control-panel");
    },
  },
};
</script>

<style></style>
